/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Guitar.glb --transform 
Files: Guitar.glb [82.64KB] > C:\Users\alexr\Documents\Development\Lofi site\public\Instruments\Guitar-transformed.glb [8.11KB] (90%)
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { Sparkles } from "@react-three/drei";

export function Guitar(props) {
  const { nodes, materials } = useGLTF("/Instruments/Guitar-transformed.glb");
  const [sound, setSound] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const clickHandler = () => {
    console.log("clicked guitar");
    if (isPlaying == false) {
      const sound = new Howl({
        src: "/sounds/guitar.wav",
        autoplay: false,
        volume: 0.3,
        onplay: () => {
          setIsPlaying(true);
          //requestAnimationFrame(step);
          // console.log(isPlaying);
          // console.log("on play");
          // requestAnimationFrame(step);
        },
        onend: () => {
          setIsPlaying(false);
        },
      });
      sound.play();

      setSound(sound);
    }
  };

  return (
    <group
      {...props}
      dispose={null}
      onClick={clickHandler}
      onPointerEnter={() => {
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={() => {
        document.body.style.cursor = "default";
      }}
    >
      {isPlaying && (
        <Sparkles
          count={100}
          scale={1}
          size={100}
          speed={2}
          color={"#00FF00"}
          position={[4.627, 4.596, -3.682]}
        />
      )}
      <group
        position={[4.627, 4.596, -3.682]}
        rotation={[-Math.PI / 2, 0, -0.009]}
        scale={120}
      >
        <mesh
          geometry={nodes.Guitar1_1.geometry}
          material={materials.Wood2Guitar1}
        />
        <mesh
          geometry={nodes.Guitar1_2.geometry}
          material={materials.Wood1Guitar1}
        />
        <mesh
          geometry={nodes.Guitar1_3.geometry}
          material={materials.Metal1Guitar1}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/Instruments/Guitar-transformed.glb");
